import { Ticket } from "callable-data-objects";
import React from "react";
import { Button, Checkbox, Icon, Message, Table } from "semantic-ui-react";
import moment from "moment";
import useCheckRole from "Hooks/APICheckRole";

type ExportDetailsProps = {
  ticket: Ticket;
};
const ExportDetails = ({ ticket }: ExportDetailsProps) => {
  const { hasRole, roles } = useCheckRole();
  const canEdit = hasRole(roles.ticket.roles.edit);
  const days = moment().diff(moment(ticket.exportRequest.requiredDate), "days");
  return (
    <Table size='small' padded={false} singleLine basic>
      <Table.Body>
        <Table.Row>
          <Table.Cell>DDI</Table.Cell>
          <Table.Cell>{ticket.exportRequest.ddi}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Associated DDIs</Table.Cell>
          <Table.Cell>{ticket.exportRequest.associatedNumbers}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Required Date</Table.Cell>
          <Table.Cell>
            {moment(ticket.exportRequest.requiredDate).format("DD/MM/YYYY")}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Past Due</Table.Cell>
          <Table.Cell>
            <Checkbox toggle checked={days > 7} />
          </Table.Cell>
        </Table.Row>
        {canEdit && (
          <Table.Row>
            <Table.Cell>Export Type</Table.Cell>
            <Table.Cell>{ticket.exportRequest.exportType}</Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          <Table.Cell>Line Type</Table.Cell>
          <Table.Cell>{ticket.exportRequest.portType}</Table.Cell>
        </Table.Row>
        {canEdit && (
          <Table.Row>
            <Table.Cell>Reference</Table.Cell>
            <Table.Cell>{ticket.exportRequest.portalReference}</Table.Cell>
          </Table.Row>
        )}
        <Table.Row>
          <Table.Cell>Postal Code</Table.Cell>
          <Table.Cell>{ticket.exportRequest.postalCode}</Table.Cell>
        </Table.Row>
        {!ticket.exportRequest.customerAccepted &&
          !ticket.exportRequest.customerRejected && (
            <Table.Row>
              <Table.Cell>Customer Actions</Table.Cell>
              <Table.Cell>
                {!hasRole(roles.ticket.export.acceptReject) && (
                  <Message warning>
                    <Icon name='warning sign' />
                    Customer has not rejected or accepted export
                  </Message>
                )}
                {hasRole(roles.ticket.export.acceptReject) && (
                  <Button.Group size='mini'>
                    <Button color='green'>Accept Export</Button>
                    <Button.Or />
                    <Button color='red' basic>
                      Reject Export
                    </Button>
                  </Button.Group>
                )}
              </Table.Cell>
            </Table.Row>
          )}
        {ticket.exportRequest.customerAccepted && (
          <Table.Row>
            <Table.Cell>Customer Accepted</Table.Cell>
            <Table.Cell>
              {moment(ticket.exportRequest.customerAcceptedDate).calendar()}
            </Table.Cell>
          </Table.Row>
        )}
        {ticket.exportRequest.customerRejected && (
          <Table.Row>
            <Table.Cell>Customer Rejected</Table.Cell>
            <Table.Cell>
              {moment(ticket.exportRequest.customerRejectedDate).calendar()}
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};

export default ExportDetails;
